export const money = (n) => `$${Number(n || 0).toLocaleString()}`;
export const inputCls = 'border-white/15 bg-white/5 text-farmway-cream placeholder:text-farmway-cream/40 focus-visible:ring-farmway-gold';
export const KYC_BADGE_CLS = {
  approved: 'bg-farmway-leaf/20 text-farmway-leaf-bright',
  submitted: 'bg-farmway-gold/20 text-farmway-gold',
  rejected: 'bg-red-500/20 text-red-400',
};
export const LISTING_BADGE_CLS = {
  settled: 'bg-farmway-leaf/20 text-farmway-leaf-bright',
  pending_settlement: 'bg-farmway-gold text-farmway-green',
};
